import type { Permission } from "../../shared/rbac/permissions";
import { isTenantScopeGrant } from "../../shared/rbac/permissions";
import { grantHasPermission } from "../../shared/rbac/roles";
import { useCurrentUserGrants } from "./useCurrentUserGrants";

// For checks across many scopes in one component, where `useHasAccess` would
// need a hook call per scope.
export function useAccessCheck(): (
  permission: Permission,
  scopeId?: string
) => boolean {
  const [allMyGrants] = useCurrentUserGrants();
  const isAdmin = allMyGrants.some(
    (g) => isTenantScopeGrant(g) && grantHasPermission(g, "allow_all")
  );
  return (permission, scopeId) =>
    (!!scopeId && isAdmin) ||
    allMyGrants.some(
      (g) =>
        (scopeId ? g.scopeId === scopeId : isTenantScopeGrant(g)) &&
        grantHasPermission(g, permission)
    );
}

export function useHasAccess(
  permission: Permission,
  scopeId?: string
): boolean {
  return useAccessCheck()(permission, scopeId);
}
